// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 404) return "static/chunks/404-448ad81ca4520bf7.js";
	if (chunkId === 822) return "static/chunks/822-c88ea6320421e53c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"792":"0b09e23f5fc293dc","2730":"23456be8a9deefc5"}[chunkId] + ".js";
};